import { CSSProperties, useEffect } from 'react'
import { Body1, Headline2 } from 'components/shareable/Typography'
import { unsubscribe_api } from 'api/fanApi'

/** 
 * Displays a confirmation message after a user has been unsubscribed
 */
const Unsubscribe = () => {

  /** 
   * Effect hook that handles unsubscribing a user from email notifications
   * Gets email and brandId from URL query params and calls unsubscribe API
   * Returns early if required params are missing
   */
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const email = params.get('email');
    const brandId = params.get('brandId');

    if (!email || !brandId) {
      return;
    }

    const unsubscribe = async () => {
      await unsubscribe_api(email, brandId)
      window.location.href = '/unsubscribe'
    }

    unsubscribe()
  }, [])

    return (
    <div style={sty.container}>
      <div style={sty.content}>
        <Headline2 style={sty.headline}>
          You have been successfully unsubscribed
        </Headline2>
        <Body1 style={sty.message}>
          You will no longer receive these email notifications.
        </Body1>
      </div>
    </div>
  )
}

const sty: Record<string, CSSProperties> = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: 32,
      backgroundColor: '#F8F9FB'
    },
    content: {
      textAlign: 'center',
      maxWidth: 600
    },
    headline: {
      marginBottom: 16,
      color: '#1A1A1A'
    },
    message: {
      color: '#666666'
    }
  }

export default Unsubscribe
